import { createI18n } from 'vue-i18n'
import type { Composer, ComposerTranslation } from 'vue-i18n'
import de from '~/locales/de'
import { isTest } from '~/helper/nuxt'

declare module '~/types/vue-shim' {
  interface AppGlobalProperties {
    $i18n: Composer // not legacy i18n
    $t: ComposerTranslation // not legacy i18n
  }
}

/**
 * Only use this in Vue and Vuetify plugin setup.
 */
export const i18nPlugin = createI18n<[typeof de], 'de' | 'en'>({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: 'de',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  missingWarn: !isTest, // prevent log cluttering
  fallbackWarn: !isTest, // prevent log cluttering
  flatJson: true, // Needed for SwitchingsEqualPaths in de.ts - maybe is more computing intensive?
  warnHtmlMessage: false, // disables warning when HTML in translations

  messages: {
    de,
    // en: Object.assign({}, de, en),
    en: de,
  },
})

export type AppI18n = typeof i18nPlugin
export type TranslateFn = typeof i18nPlugin.global.t

declare global {
  interface Window {
    __i18n__?: AppI18n
  }
}

window.__i18n__ = i18nPlugin
export default i18nPlugin
